<template>
    <div id="check_list_action_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="checkListActionHeader" v-if="$route.params.id > 0">Update Checklist Action</span>
                    <span class="page-title" id="checkListActionHeader" v-else>Add Checklist Action</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackChecklistActionList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content checklist-action-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="checkListForm">
                                <div class="form-row">
                                    <div class="col-sm-6">
                                        <label class="control-label require" for="name">Action Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Action Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateCheckListActionBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateChecklistAction" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateCheckListActionBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateChecklistAction" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueCheckListActionBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateChecklistAction(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelCheckListActionBtn" class="btn btn-tertiary" v-on:click.prevent="BackChecklistActionList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
export default {
  name: "ChecklistActionCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Checklist Action | " +process.env.COPYRIGHT_NAME : "Create Checklist Action | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    loading:false,
    name_error_msg: "",    
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_checklist_action') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if (segments[3]) {
                self.loadChecklistAction();
            }
        }, 100);
  },
  methods: {
    BackChecklistActionList() {
      var self = this;
      self.$router.push("/checklist-action/list");
    },

    CreateChecklistAction(flag) {
      var self = this;

      self.name = self.name.trim();

      self.name_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Action Name Required.";
      }
      
      if (self.name_error_msg == "") {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateCheckListActionBtn").val("Updating ...");
                $("#CreateCheckListActionBtn").prop("disabled", true);
                $("#cancelCheckListActionBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueCheckListActionBtn").val("Saving ...");
                    $("#CreateCheckListActionBtn").prop("disabled", true);
                    $("#createAndContinueCheckListActionBtn").prop("disabled", true);
                    $("#cancelCheckListActionBtn").prop("disabled",true);

                }else{

                    $("#CreateCheckListActionBtn").val("Saving ...");
                    $("#CreateCheckListActionBtn").prop("disabled", true);
                    $("#createAndContinueCheckListActionBtn").prop("disabled", true);
                    $("#cancelCheckListActionBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/checklist-action/create",
                type: "POST",
                data: {name: self.name, id: segments[3]},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateCheckListActionBtn").val("Update");
                        $("#CreateCheckListActionBtn").prop("disabled", false);
                        $("#cancelCheckListActionBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCheckListActionBtn").val("Save and Continue");
                            $("#CreateCheckListActionBtn").prop("disabled", false);
                            $("#createAndContinueCheckListActionBtn").prop("disabled", false);
                            $("#cancelCheckListActionBtn").prop("disabled",false);

                        }else{

                            $("#CreateCheckListActionBtn").val("Save");
                            $("#CreateCheckListActionBtn").prop("disabled", false);
                            $("#createAndContinueCheckListActionBtn").prop("disabled", false);
                            $("#cancelCheckListActionBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#checkListForm").trigger("reset");
                            self.name ="";                            
                    
                        }else{
                            self.$router.push("/checklist-action/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateCheckListActionBtn").val("Update");
                        $("#CreateCheckListActionBtn").prop("disabled", false);
                        $("#cancelCheckListActionBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#checkListForm").trigger("reset");
                            

                            $("#createAndContinueCheckListActionBtn").val("Save and Continue");
                            $("#CreateCheckListActionBtn").prop("disabled", false);
                            $("#createAndContinueCheckListActionBtn").prop("disabled", false);
                            $("#cancelCheckListActionBtn").prop("disabled",false);

                        }else{

                            $("#CreateCheckListActionBtn").val("Save");
                            $("#CreateCheckListActionBtn").prop("disabled", false);
                            $("#createAndContinueCheckListActionBtn").prop("disabled", false);
                            $("#cancelCheckListActionBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'load-checklist-action-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }
    },

    loadChecklistAction() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/checklist-action/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                
                if (data.status == "success") {
                    self.name = data.content.name;                    
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-checklist-action-by-id')
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ChecklistActionCreate.vue